import React, { useEffect, useState } from "react";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { Col, Empty, Input, Row, Skeleton, Table, Button } from "antd";
import { map, get } from "lodash";
import moment from "moment";

import { recordError } from "../../../utils/logService";
import nysProgrammeService from "../../../services/nysProgrammeService";
import EditNYSProgramme from "./EditNYSProgramme";
import ViewNYSProgramme from "./ViewNYSProgramme";
import AddNYSProgramme from "./AddNYSProgramme";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

const NYSProgrammeList = ({ hasUpdated, setHasUpdated }) => {
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [nysProgrammeData, setNysProgrammeData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalType, setModalType] = useState("view");
  const [data, setData] = useState({});

  useEffect(() => {
    if (hasUpdated === true) {
      getNYSProgramme();
    }
  }, [hasUpdated]);

  let msg = "";

  const showModal = (record, show, type = "none") => {
    setModalType(type);
    setData(record);
    setVisible(show);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      showOnResponse: true,
      showOnDesktop: true,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      showOnResponse: true,
      showOnDesktop: true,
    },
    {
      title: "Financial year",
      dataIndex: "financialYear",
      key: "financialYear",
      showOnResponse: true,
      showOnDesktop: true,
      sorter: (a, b) => a.financialYear.localeCompare(b.financialYear),
      defaultSortOrder: "descend",
    },
    {
      title: "Start date",
      dataIndex: "startDate",
      key: "startDate",
      showOnResponse: true,
      showOnDesktop: true,
    },
    {
      title: "End date",
      dataIndex: "endDate",
      key: "endDate",
      showOnResponse: true,
      showOnDesktop: true,
    },
    {
      title: "Actions",
      dataIndex: "edit",
      key: "actions",
      showOnResponse: true,
      showOnDesktop: true,
      render: (_, record) => {
        return (
          <>
            <a key={record.key} onClick={() => showModal(record, true, "view")}>
              View
            </a>
            <a
              key={record.key}
              onClick={() => showModal(record, true, "edit")}
              style={{ marginLeft: 10 }}
            >
              Edit
            </a>
          </>
        );
      },
    },
  ];

  const onRowChange = (row) => {
    setPageSize(row.pageSize);
  };

  const handleInputChange = (e) => {
    const { value: searchValue } = e.target;
    setSearchText(searchValue);
    globalSearch(searchValue);
  };

  const getNYSProgramme = async () => {
    setSearchText("");
    const entity = "nys";
    setNysProgrammeData([]);
    try {
      setLoading(true);
      const response = await nysProgrammeService.getProgrammeList();
      if (response && response.status === 200) {
        const { data } = response;
        var programmeData = data?.map((element, index) => ({
          key:
            index.toString() +
            element.id.toString() +
            "x" +
            element.financialYearShortValue,
          id: element.id,
          name: element.name,
          description: element.description,
          financialYearId: element.financialYearId,
          financialYear: element?.financialYearValue,
          // startDate: new Date(element.startDate)?.toLocaleDateString(
          //   "en-ZA",
          //   dateOptions
          // ),
          // endDate: new Date(element.endDate)?.toLocaleDateString(
          //   "en-ZA",
          //   dateOptions
          // ),
          start_date: element.startDate,
          end_date: element.endDate,
          startDate: moment(element.startDate).format("dddd, Do MMM YYYY, HH:mm") ,
          endDate:  moment(element.endDate).format("dddd, Do MMM YYYY, HH:mm"),

          contactName: element.nysContact.name,
          surname: element.nysContact.surname,
          title_id: element.nysContact.title_id,
          email: element.nysContact.email,
          contactNumbers: element.nysContact?.contactNumbers,
        }));
        setNysProgrammeData(programmeData);
        setFilteredData(programmeData);
      }
      setLoading(false);
    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE, entity);
      openNotification(
        "System failed to load NYS programme",
        msg,
        Notify.ERROR
      );
      recordError(error);
    }
    setHasUpdated(false);
  };

  const globalSearch = (searchValue) => {
    if (searchText === "") {
      setFilteredData(nysProgrammeData);
      return;
    }

    const reg = new RegExp(
      searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"),
      "gi"
    );

    var _filteredData = map(nysProgrammeData, (record) => {
      const nameMatch = get(record, "name").match(reg);
      const descriptionMatch = get(record, "description").match(reg);

      if (!nameMatch && !descriptionMatch) {
        return null;
      }
      return record;
    }).filter((record) => record);

    setSearchText(searchValue);
    setFilteredData(_filteredData);
  };

  return (
    <>
      <div key={"title"}>List of NYS Programmes</div>
      <Row key={"search-info"} justify="space-between">
        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
          <Input
            key="search"
            placeholder="Search NYS Programme"
            type="text"
            className="search-bar"
            onChange={handleInputChange}
            allowClear
            size="large"
            prefix={<SearchOutlined />}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={4} xl={2}>
          <Button
            className="add-button"
            style={{ bottom: 12 }}
            key="add-button"
            type="primary"
            onClick={() => showModal({}, true, "none")}
            icon={<PlusOutlined />}
          >
            {""} Add New
          </Button>
        </Col>
      </Row>
      {/* <div key={2} className="space">
        {modalType}
      </div> */}

      <Table
        key={"programme-table"}
        dataSource={loading ? [] : filteredData}
        locale={{
          emptyText: loading ? <Skeleton active={true} /> : <Empty />,
        }}
        rowKey={(record) => record.key}
        columns={columns}
        bordered
        pagination={{ pageSize: pageSize }}
        onChange={onRowChange}
        size="middle"
        mobileBreakPoint={768}
      />

      {modalType === "none" && (
        <AddNYSProgramme
          key={"add-nys-prgramme"}
          visible={visible}
          onShow={showModal}
          setHasUpdated={setHasUpdated}
        />
      )}
      {modalType === "view" && (
        <ViewNYSProgramme
          key={"view-nys-prgramme"}
          record={data}
          onShow={showModal}
          visible={visible}
          hasUpdated={hasUpdated}
          setHasUpdated={setHasUpdated}
        />
      )}

      {modalType === "edit" && (
        <EditNYSProgramme
          key={"edit-nys-prgramme"}
          record={data}
          onShow={showModal}
          visible={visible}
          hasUpdated={hasUpdated}
          setHasUpdated={setHasUpdated}
        />
      )}
    </>
  );
};

export default NYSProgrammeList;
